(() => {
  const config = document.querySelector('script[data-fs-structured-data]');
  if (!config) return;
  const { pageUrl, shopUrl, shopName, reviews } = config.dataset;
  const text = (element) => (element?.textContent || '').replace(/\s+/g, ' ').trim();

  function writeSchema(id, value) {
    let script = document.getElementById(id);
    if (!value) {
      script?.remove();
      return;
    }
    const json = JSON.stringify(value).replace(/</g, '\\u003c');
    if (script?.textContent === json) return;
    if (!script) {
      script = document.createElement('script');
      script.id = id;
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.textContent = json;
  }

  function updateReviews() {
    const entries = new Map();
    document.querySelectorAll('.jdgm-all-reviews-widget .jdgm-rev').forEach((item) => {
      if (item.hidden || item.getAttribute('aria-hidden') === 'true' || !item.getClientRects().length) return;
      const author = text(item.querySelector('.jdgm-rev__author'));
      const body = text(item.querySelector('.jdgm-rev__body'));
      const rating = Number(item.querySelector('.jdgm-rev__rating')?.getAttribute('data-score'));
      if (!author || !body || !Number.isFinite(rating) || rating < 1 || rating > 5) return;
      const productLink = item.querySelector('.jdgm-rev__prod-link');
      let itemReviewed;
      if (productLink) {
        const name = text(productLink);
        let url;
        try {
          url = new URL(productLink.getAttribute('href') || '', shopUrl);
        } catch {
          return;
        }
        if (!name || !['https:', 'http:'].includes(url.protocol) || !url.pathname.includes('/products/')) return;
        url.search = '';
        url.hash = '';
        itemReviewed = { '@type': 'Product', '@id': url.href, name, url: url.href };
      } else {
        // Only explicitly identified shop reviews can be attributed to the store.
        if (item.getAttribute('data-review-type') !== 'shop') return;
        itemReviewed = { '@type': 'Organization', name: shopName, url: shopUrl };
      }
      const entry = {
        '@type': 'Review', itemReviewed,
        author: { '@type': 'Person', name: author },
        reviewBody: body,
        reviewRating: { '@type': 'Rating', ratingValue: rating, bestRating: 5, worstRating: 1 }
      };
      const title = text(item.querySelector('.jdgm-rev__title'));
      if (title) entry.name = title;
      const key = item.getAttribute('data-review-id') || JSON.stringify(entry);
      entries.set(key, entry);
    });
    writeSchema('fs-reviews-schema', entries.size ? {
      '@context': 'https://schema.org', '@type': 'CollectionPage',
      '@id': `${pageUrl}#reviews`, url: pageUrl,
      name: document.title,
      mainEntity: {
        '@type': 'ItemList',
        itemListElement: Array.from(entries.values(), (item, index) => ({
          '@type': 'ListItem', position: index + 1, item
        }))
      }
    } : null);
  }

  let timer;
  function update() {
    if (reviews === 'true') updateReviews();
  }
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(update, 100);
  }
  update();
  // Observe the body only: writing JSON-LD to the head cannot trigger a loop.
  new MutationObserver(schedule).observe(document.body, {
    childList: true, subtree: true, characterData: true, attributes: true,
    attributeFilter: ['class', 'style', 'hidden', 'aria-hidden', 'data-score']
  });
  document.addEventListener('shopify:section:load', schedule);
})();
